import { Component, ElementRef, Inject, Input, Optional, ViewChild } from '@angular/core';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { ImageCroppedEvent, ImageCropperComponent, LoadedImage } from 'ngx-image-cropper';

@Component({
  selector: 'app-modal-image-cropper',
  templateUrl: './modal-image-cropper.component.html'
})
export class ModalImageCropperComponent {
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('imageCropper') imageCropper!: ImageCropperComponent;

  initialImageBase64 = '';

  constructor(@Optional() @Inject(NZ_MODAL_DATA) data?: { initialImageBase64?: string }) {
    if (data?.initialImageBase64) {
      this.initialImageBase64 = data.initialImageBase64;
    }
  }
  @Input() aspectRatio = 1 / 1;
  @Input() maintainAspectRatio = true;

  imageChangedEvent: Event | null = null;
  croppedImage: string = '';

  imageCropped(event: ImageCroppedEvent) {
    if (event.base64) {
      this.croppedImage = event.base64;
    }
  }

  imageLoaded(image: LoadedImage) {
    // show cropper
  }

  cropperReady() {
    // cropper ready
  }

  loadImageFailed() {
    // show message
  }

  getCroppedImageBase64() {
    return this.croppedImage;
  }
}
